import React, { Component } from 'react'
import './Home.css'

import Res from '../values/Resources'

import Menu from '../components/Menu'
import Hero from '../components/Hero'
import Banner from '../components/Banner'
import Portfolio from '../components/Portfolio'

export default class Home extends Component {
	constructor(props) {
		super(props)

		const languageCode = localStorage.getItem('language_code')

		this.state = {
			scrollTop: 0,
			menuVisible: false,
			menuBtnVisible: true,
			menuBtnWhite: false,
			language: languageCode//'en'
		}
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll)
		//window.addEventListener('mousewheel', this.handleMouseWheel)
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll)
		//window.removeEventListener('mousewheel', this.handleMouseWheel)
	}

	handleScroll = (event) => {
		let { scrollTop } = event.srcElement.scrollingElement

		console.log('scroll ' + scrollTop)

		if(!this.state.menuVisible)
			this.lastScroll = scrollTop
		
	}

	handleOnMenuClick = () => {
		console.log('click')
		this.setState({
			menuVisible: !this.state.menuVisible,
			scrollTop: this.lastScroll
		})
		console.log('lastScroll = ' + this.lastScroll)
	}

	handleLanguageSelection = (code) => {
		console.log('language change')
		Res.locale(code)
		localStorage.setItem('language_code', code)
		this.setState({ language: code })
	}

	render() {
		return (
			<div id='home'>
				<Menu
				  scrollTop={this.state.scrollTop}
				  visible={this.state.menuVisible}
				  language={this.state.language}
				  buttonVisible={this.state.menuBtnVisible}
				  buttonWhite={this.state.menuBtnWhite}
				  buttonActive={this.state.menuVisible}
				  onButtonClick={this.handleOnMenuClick}
				  onLanguageSelected={this.handleLanguageSelection}>
					<Hero/>
					<Banner/>
					<Portfolio/>
				</Menu>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/Home.js